module.exports = new __parcel__URL__("kaiju_kingmaker_level_2.98dd517a.png").toString();